import { NavLink } from "react-router-dom";

import LazyLoad from "components/LazyLoad";
import AnimatedWitch from "assets/images/about-us/AnimatedWitch.gif";
import AnimatedBear from "assets/images/about-us/AnimatedBear.gif";
import AnimatedHeart from "assets/images/about-us/AnimatedHeart.gif";
import starringYouTitile from "assets/images/about-us/StarringYouTitle.svg";
import faceMove from "assets/images/about-us/FaceMove.png";
import { appRoutes } from "routes";

import {
  StyledGrid,
  RowTitle,
  AnimatedLogo,
  TitleLogo,
  Text,
  Title,
  StyledLink,
  RowFaces,
  HeadIcon,
  WitchGif,
} from "./styles";

const LearnMoreAboutStarringYou = () => {
  return (
    <StyledGrid container direction="column" justifyContent="start" alignItems="center" textAlign="center">
      <Title variant="h1">Learn More About</Title>

      <RowTitle>
        <LazyLoad lazy>
          <AnimatedLogo src={AnimatedBear} alt="Starring You® bear" width={250} widthMobile={130} />
        </LazyLoad>
        <TitleLogo src={starringYouTitile} alt="Starring You® logo" />
        <LazyLoad lazy>
          <AnimatedLogo src={AnimatedHeart} alt="Starring You® heart" width={250} widthMobile={130} />
        </LazyLoad>
      </RowTitle>

      <Text data-testid="text" align="center">
        Starring You® is our bread and butter, our jam, our special sauce…you get the point. Folks use JibJab to
        personalize{" "}
        <StyledLink exact to={appRoutes.categoriesPath()} component={NavLink}>
          Ecards
        </StyledLink>{" "}
        and{" "}
        <StyledLink exact to={appRoutes.categoryPath("music-video-ecards")} component={NavLink}>
          Videos
        </StyledLink>{" "}
        with their own face, or faces of friends and family. These fun and hilarious videos are shared via text, email,
        Facebook, Instagram, TikTok, and beyond.
      </Text>
      <RowFaces>
        <LazyLoad lazy>
          <HeadIcon src={faceMove} alt="face" width={400} widthMobile={200} />
        </LazyLoad>
        <LazyLoad lazy>
          <WitchGif src={AnimatedWitch} alt="Starring You® witch" width={400} widthMobile={150} />
        </LazyLoad>
      </RowFaces>

      <Title paragraph>Stick Your Face in Fun Characters!</Title>
    </StyledGrid>
  );
};

export default LearnMoreAboutStarringYou;
